import datepicker from 'js-datepicker';

import Form from '../_form';
import Cookies from '../../utils/class/cookies';

import formatDate from '../../utils/date';

export default class JobCreateForm extends Form {

    /* eslint-disable no-useless-constructor */
    constructor (query) {
        super(query);

        let { jobID } = this.setCookies();

        if (this.cookies.getProperty('pp_creation', 'job/project') !== new FormData(this.form).get('project-id')) {
            this.cookies.delete('pp_creation');

            jobID = null;
        };

        this.jobID = jobID || this.setDraft();

        this.setSave();

        this.setDatepicker();

        this.setNavigation();
    }

    setCookies () {
        this.cookies = new Cookies();

        return {
            jobID: this.cookies.getProperty('pp_creation', 'job/id')
        }
    }

    async setDraft () {
        try {
            await fetch('/wp-json/jobs/v1/draft', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' }
            })
            .then((response) => response.json())
            .then((data) => {
                if (data && !data.error) {
                    this.jobID = data.id;

                    this.cookies.set('pp_creation', { job: { id: data.id, project: new FormData(this.form).get('project-id'), step: 1 } }, { expires: 1800 });

                    this.NotificationManager.sendNotification('success', 'New job draft created!', data.message);
                } else {
                    this.NotificationManager.sendNotification('error', 'Draft creation error...', data.message);
                }
            })
            .catch(() => {
                this.NotificationManager.sendNotification('error', 'Draft creation error...', 'Please, try to reload the page');
            });
        } catch (error) {
            this.NotificationManager.sendNotification('error', 'Draft creation error...', 'Please, try to reload the page');
        }
    }

    setSave () {
        this.fields.forEach((field) => {
            const input = field.querySelector('input, textarea');

            const save = async (value, name) => {
                try {
                    await fetch('/wp-json/jobs/v1/save', {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify({ id: this.jobID, name, value })
                    })
                    .then((response) => response.json())
                    .then((data) => {
                        if (data && !data.error) {
                            this.NotificationManager.sendNotification('success', 'Data saved!', data.message);
                        } else {
                            this.NotificationManager.sendNotification('error', 'Data save error...', data.message);
                        }
                    })
                    .catch(() => {
                        this.NotificationManager.sendNotification('error', 'Data save error...', 'Please, try to reload the page');
                    });
                } catch (error) {
                    this.NotificationManager.sendNotification('error', 'Data save error...', 'Please, try to reload the page');
                }
            };

            input.addEventListener('change', () => {
                if (field.classList.contains('site-field--error')) return;

                save(input.value, input.name);
            });
        });
    }

    setDatepicker () {
        const field = this.form.querySelector('#expiration-date');
        if (!field) return;

        const today = new Date();
        const tomorrow = new Date();

        tomorrow.setDate(today.getDate() + 1);

        const maxDateString = field.dataset.max;
        const [maxDay, maxMonth, maxYear] = maxDateString.split('.');

        this.datepicker = datepicker('#expiration-date', {
            minDate: tomorrow,
            maxDate: new Date(`${maxYear}-${maxMonth}-${maxDay}`),
            onSelect: () => field.dispatchEvent(new Event('change')),
            formatter: (input, date) => {
                const parsed = date.toLocaleString('en-GB').split(',')[0];
                const formatted = parsed.split('/').reverse().join('-');

                const value = formatDate(formatted, 'MMMM d, yyyy');

                input.value = value;
            },
            onShow: () => field.classList.add('triggered'),
            onHide: () => field.classList.remove('triggered')
        });

        if (field.value) {
            const [day, month, year] = field.value.split('.');
            const date = new Date(`${year}-${month}-${day}`);

            if (date) this.datepicker.setDate(date);
        }
    }

    setNavigation () {
        const validateStep = (step) => {
            const fields = step.querySelectorAll('.site-field');
            if (!fields || !fields.length) return;

            const required = [...fields].filter((field) => field.dataset.required === 'true');
            if (!required || !required.length) return;

            const next = step.querySelector('.primary[data-step]');

            const validation = this.validateFields(required, false);

            if (next) {
                next.removeAttribute('disabled');

                /* eslint-disable-next-line no-unused-expressions */
                validation ? next.removeAttribute('disabled') : next.setAttribute('disabled', '');
            }
        };

        const validateForm = () => {
            const fields = this.form.querySelectorAll('.site-field');
            if (!fields || !fields.length) return;

            const required = [...fields].filter((field) => field.dataset.required === 'true');
            if (!required || !required.length) return;

            const validation = this.validateFields(required, false);

            if (this.submit) {
                /* eslint-disable-next-line no-unused-expressions */
                validation ? this.submit.removeAttribute('disabled') : this.submit.setAttribute('disabled', '');
            }
        }

        const steps = [...this.form.querySelectorAll('.site-creation--step')];
        const navs = [...this.form.querySelectorAll('.site-creation--navigation ul li[data-step]')];

        const activateStep = (key = 1) => {
            const target = steps.find((s) => s.dataset.formStep === `${key}`);
            if (!target) return;
    
            steps.forEach((s) => s.classList.remove('active'));
            target.classList.add('active');
    
            window.scrollTo({ top: 0, behavior: 'smooth' });
    
            navs.forEach((nav) => nav.classList.remove('active'));
            navs.filter((nav) => nav.dataset.step <= key).forEach((nav) => nav.classList.add('active'));

            this.cookies.setProperty('pp_creation', 'job/step', key);

            validateStep(target);

            validateForm();
        };
    
        activateStep(this.cookies.getProperty('pp_creation', 'job/step'));
        validateForm();

        steps.forEach((step) => {
            const buttons = step.querySelectorAll('[data-step]');
            if (!buttons || !buttons.length) return;
    
            buttons.forEach((button) => {
                const key = button.dataset.step;
    
                button.addEventListener('click', (event) => {
                    event.preventDefault();
                    event.stopPropagation();

                    activateStep(key);
                });
            });

            const fields = step.querySelectorAll('.site-field');
            if (!fields || !fields.length) return;

            const required = [...fields].filter((field) => field.dataset.required === 'true');
            if (!required || !required.length) return;

            required.forEach((field) => {
                const input = field.querySelector('input, textarea');

                ['change', 'input'].forEach((type) => {
                    input.addEventListener(type, (event) => {
                        event.stopPropagation();
    
                        validateStep(step);
                        validateForm();
                    });
                });
            });
        });
    }

    async finalizeForm () {
        if (this.submit) this.submit.classList.add('preload');

        const formData = new FormData(this.form);

        const id = this.jobID;

        if (!id) {
            this.NotificationManager.sendNotification('error', 'Job draft unavailable...', 'Please, try again later');

            return;
        }

        const project = formData.get('project-id');
        const type = formData.get('type');
        const category = formData.get('category');
        const title = formData.get('title');
        const description = formData.get('description');
        const cover = formData.get('cover-image-url') || '';
        const price = formData.get('price');
        const date = formData.get('expiration-date');
        const location = formData.get('location');

        try {
            await fetch('/wp-json/jobs/v1/create', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ id, project, type, category, title, description, cover, price, date, location })
            })
            .then((response) => response.json())
            .then((data) => {
                if (data && !data.error) {
                    this.form.classList.remove('error');
                    this.form.classList.add('sent');

                    this.cookies.delete('pp_creation');

                    this.NotificationManager.sendNotification('success', 'Job created! Redirecting...', data.message);

                    setTimeout(() => window.location.href = data.url, 3000);
    
                    if (this.submit) this.submit.classList.remove('preload');
                } else {
                    this.NotificationManager.sendNotification('error', 'An error occurred...', data.message);

                    if (this.submit) this.submit.classList.remove('preload');

                    this.form.classList.add('error');
                }
            })
            .catch(() => {
                this.NotificationManager.sendNotification('error', 'An error occurred...', 'Please, try again');

                if (this.submit) this.submit.classList.remove('preload');

                this.form.classList.add('error');
            });
        } catch (error) {
            this.NotificationManager.sendNotification('error', 'An error occurred...', 'Please, try again');

            if (this.submit) this.submit.classList.remove('preload');

            this.form.classList.add('error');
        }
    }
}